import React, { useState, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { convertEpochTime, getEndpoint, getUrl, showMultipleAuthor, setCmsSeoData, isLoggedIn, GetIconsSprites, getAuthorCardTwo } from './../../../common/utils';
import { SocialShareTwo } from "../SocialShareTwo/SocialShareTwo";
import './VideoShowTwo.css';
import Tag from "../../Tag/Tag";
import { URL_PROTOCAL } from '../../Common/Constant';
import MediaPlayerWrapper from '../MediaPlayerWrapper';
import { PAGEBUILDER_URLS } from '../../Common/Constant';
// import { FrontAwesomeIcon } from '@fortawesome/react-frontawesome';
// import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import bcrypt from 'bcryptjs-react';
VideoShowTwo.version = 1000;
VideoShowTwo.lang = 'en';
VideoShowTwo.langs = [
    'en'
];
VideoShowTwo.setLang = (lang: any) => {
    VideoShowTwo.lang = lang;
}

Object.defineProperty(VideoShowTwo, 'name', {
    writable: true,
    value: 'VideoShowTwo'
});

export function VideoShowTwo(props: any) {

    const { anchorLinksValue, authorCard } = props;

    const [videoShowData, setVideoShowData] = useState<any>({});
    const { showTags } = props;
    let REQUEST_HOSTNAME: any = null;
    if (props && props.REQUEST_HOSTNAME) {
        REQUEST_HOSTNAME = props.REQUEST_HOSTNAME;
    }
    let REQUEST_URL: any = null;
    if (props && props.REQUEST_URL) {
        REQUEST_URL = props.REQUEST_URL;
    }
    const endpoint = getEndpoint(props, "MAIN");
    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            fetchComponentData();
        }

        if (videoShowData && videoShowData.it && videoShowData.it.primeId) {
            isLoggedIn();
        }
    }, [authorCard])

    const addExportedData = (object: any) => {
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.pid !== "undefined"
            && object.folderId != null && object.folderId != "") {
            props.exportedKeys.pid = object.folderId;
        }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.sectionid !== "undefined"
            && object.id != null && object.id != "") {
            props.exportedKeys.sectionid = object.id;
        }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.authorid !== "undefined"
            && typeof object.authors != "undefined" && object.authors.length > 0) {
            props.exportedKeys.authorid = object.authors[0].id;
        }
        if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.tags !== "undefined"
            && typeof object.kws != "undefined" && object.kws.length > 0) {
            const names = object.kws.map((item: any) => item.name).join(',');
            props.exportedKeys.tags = names;
        }
    }

    if (endpoint.isSSR && endpoint.SSRDataObj && videoShowData && Object.keys(videoShowData).length === 0
        && endpoint.SSRDataObj.items.length > 0) {
        setVideoShowData(endpoint.SSRDataObj.items[0]);
        addExportedData(endpoint.SSRDataObj.items[0]);
        setCmsSeoData(props, endpoint.SSRDataObj.items[0], "VideoShow");
    }

    const fetchComponentData = () => {
        let videoUrl = getUrl(props, 0, false, "MAIN", true);
        let headerString = '?' + videoUrl.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = { 'p-nonce': headerString };
        fetch(videoUrl, { headers: headers })
            .then(data => data.json())
            .then(val => {
                setVideoShowData(val.items[0])
                addExportedData(val.items[0])
                setCmsSeoData(props, val.items[0], "VideoShow");
            })
    }

    const showCredits = () => {
        if (!videoShowData) {
            console.error('videoShowData is null or undefined');
            return <></>; // Return an empty fragment or some fallback UI
        }

        const { authors = [], pubInfo = {}, ag = [], upd } = videoShowData;
        const baseDomain = pubInfo ? pubInfo.baseDomain : '';

        let creditComponent = []
        const authorContent = showMultipleAuthor(authors, baseDomain)
        if (props.showAuthorName && authorContent.length != 0) {
            creditComponent.push(authorContent)
        }
        if (props.showNewsAgency && ag && ag.length != 0) {
            creditComponent.push(ag)
        }
        let formattedDate = '';
        formattedDate = convertEpochTime(upd, 'updated', 'MMM DD, YYYY, HH:MM TZ') as string;



        if (formattedDate && props.showTimeStamp) {
            creditComponent.push(formattedDate)
        }
        let creditStr = creditComponent.join(" | ")
        return <><span className='articalShowAuthr' dangerouslySetInnerHTML={{ __html: creditStr }} /></>
    }

    const isDataAvailable = videoShowData && Object.keys(videoShowData).length > 0;
    let slikeId = '';
    if (isDataAvailable && videoShowData?.media) {
        if (videoShowData?.media?.rmid === 10) {
            slikeId = 'yt' + videoShowData?.media?.id;
        } else {
            slikeId = videoShowData?.media?.id;
        }
    }
    // console.log("Video Show Data:", videoShowData);
    // console.log("Slike ID:", slikeId);

    return (
        <React.Fragment>
            <Grid className="video-show-page">
                <Grid item sm={12} xs={12} className='videofullbox'>
                    <div>
                        {
                            typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url)) ?
                                <div className="video-box">
                                    {isDataAvailable && videoShowData?.media &&
                                        <div style={{ position: 'relative' }}>
                                            <img src={`/thumb/${videoShowData?.imageid.split('&')[0]}.cms?${videoShowData?.imageid.split('&')[1]}&width=760&height=428&resizemode=75`} alt={videoShowData?.hl?.slice(0, 25)} title={videoShowData?.hl?.slice(0, 25)} />
                                            <div className='ThemeTwoVideoIcon'>
                                                {/* <FrontAwesomeIcon icon={faPlayCircle} /> */}
                                                <div style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                :
                                <div>
                                    <MediaPlayerWrapper
                                        containerId={`playerContainer_${slikeId}`}
                                        apiKey="test403web5a8sg6o9ug"
                                        slikeId={slikeId}
                                        Pl_Type='Video'
                                        autoPlay={true}
                                        skipAd={true}
                                        mute={false}
                                        playInBackground={true}
                                        pipMode={true}
                                    />

                                </div>
                        }
                    </div>

                </Grid>
                <Grid item md={12}>
                    <div className="video-title">
                        <Typography className="story-heading" variant='h2'>
                            {videoShowData && videoShowData?.hl}
                        </Typography>
                    </div>
                    <Grid container item md={12} position={'relative'} direction="column">
                        <div className='themeTwoVideoWrapAfency'>
                            {/* {isDataAvailable && getAuthorDetails()}
                    {isDataAvailable && getAgencyDetails()}
                    {isDataAvailable && getDateTime()} */}
                            {showCredits()}
                        </div>
                    </Grid>
                    <div className='socialMediaWrap'>
                        <div className='commonSocialListWrap'>
                            {
                                <SocialShareTwo
                                    shareUrl={URL_PROTOCAL + REQUEST_HOSTNAME + REQUEST_URL}
                                    shareText={videoShowData?.hl} showFacebook={true}
                                    showTwitter={true}
                                    showLinkedin={true}
                                    showWhatsapp={true}
                                    showPintrest={true} />
                            }
                        </div>
                    </div>
                    <div className="video-article-summary">
                        <Typography>
                            {videoShowData && videoShowData?.Story}
                        </Typography>

                        <div className='videoShowAuthorCard'>
                            {authorCard && videoShowData.authorDetails && Array.isArray(videoShowData.authorDetails) && videoShowData.authorDetails.length >= 0 &&
                                videoShowData.authorDetails.map((authorDetail: any) => (
                                    getAuthorCardTwo(props, authorDetail)
                                ))
                            }
                        </div>
                    </div>
                </Grid>

                <Grid container direction="row" className='tag_dnone'>
                    <Grid item sm={12}>
                        {videoShowData && showTags && videoShowData?.pubInfo && <Tag baseDomain={videoShowData?.pubInfo?.baseDomain} tagsData={videoShowData?.kws} anchorLinksValue={anchorLinksValue} />}
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
